import { render, staticRenderFns } from "./AlertButton.vue?vue&type=template&id=64069a9c&scoped=true&"
import script from "./AlertButton.vue?vue&type=script&lang=ts&"
export * from "./AlertButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64069a9c",
  null
  
)

export default component.exports